export enum BlockBackgroundColor {
	White,
	Grey,
	Pink,
	Purple,
	Green,
}
